<template>
    <SlideUpTransition>
        <footer class="dark-blue">
            <div class="spacing-alternative">
                <div class="upper-footer">
                    <address class="basis-full sm:basis-auto order-2 sm:order-1 w-full sm:w-auto">
                        <a :href="`mailto:${globals?.pagemeta?.email}`" title="E-Mail schreiben">{{ globals.pagemeta?.email }}</a>
                        <a :href="`tel:${cleanPhoneNumber}`" title="Call us">{{ globals.pagemeta?.phone_number }}</a>
                        <br>
                        <a href="https://maps.app.goo.gl/GznubMByY5YPys2R9" title="Find your way" target="_blank">
                            {{ globals?.pagemeta?.company_name }}<br>
                            {{ globals?.pagemeta?.address }}<br>
                            {{ globals?.pagemeta?.city }}
                        </a>
                    </address>
                    <MediaElement 
                        :src="'/ws-logo-basic.svg'" 
                        :alt="'W-S Logo'"
                        :classes="'logo basis-auto self-end sm:self-start order-1 sm:order-2 mb-2 sm:mb-0'">
                    </MediaElement>
                </div>
                <div class="w-full">
                    <div class="lower-footer flex-default">
                        <MenueWidget :menuType="'service'" />

                        <div class="copyright-box">
                            <span>{{ thisYear }} &copy; {{ globals?.pagemeta?.company_name }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </SlideUpTransition>
</template>

<script setup lang="ts">
    import { useRequestStore } from '@/stores/requests'

    const requestStore = useRequestStore()
    const { globals } = storeToRefs(requestStore)

    const thisYear = computed(() => {
        return new Date().getFullYear()
    })

    const cleanPhoneNumber = computed(() => {
        const phone = globals.value.pagemeta?.phone_number.replace(/[&\/\\#,()$~%.'":*?<>{}]/g, '')

        return phone
    })
</script>